export const clientTestimonials = {
  en: [
    {
      id: 1,
      name: "Gulina & Chyngyzbek Family",
      location: "Pittsburgh, PA",
      message: "We are so grateful for the amazing service! As a young family, we never thought we could afford our dream home. The team guided us through every step and made our homeownership dream come true in April 2025!",
      loanAmount: "$350,000",
      loanType: "30-Year Fixed",
      photo: "/images/clients/Gulina April 2025.jpg"
    },
    {
      id: 2,
      name: "Nara",
      location: "Spring Brook, PA",
      message: "The mortgage process was seamless and professional! I found my perfect home in Spring Brook and the team made the financing effortless. Closing on my $515,000 home in August 2025 was a dream come true!",
      loanAmount: "$515,000",
      loanType: "30-Year Fixed Mortgage",
      photo: "/images/clients/Nara July 2025.jpg"
    }
  ],
  ru: [
    {
      id: 1,
      name: "Семья Гулины и Чынгызбека",
      location: "Питтсбург, Пенсильвания",
      message: "Мы так благодарны за потрясающий сервис! Как молодая семья, мы никогда не думали, что сможем позволить себе дом мечты. Команда провела нас через каждый шаг и воплотила нашу мечту о домовладении в апреле 2025 года!",
      loanAmount: "$350,000",
      loanType: "30-летняя фиксированная",
      photo: "/images/clients/Gulina April 2025.jpg"
    },
    {
      id: 2,
      name: "Нара",
      location: "Спринг Брук, Пенсильвания",
      message: "Процесс получения ипотеки был плавным и профессиональным! Я нашла свой идеальный дом в Спринг Брук, и команда сделала финансирование легким. Закрытие сделки на мой дом за $515,000 в августе 2025 года было мечтой, ставшей реальностью!",
      loanAmount: "$515,000",
      loanType: "30-летняя фиксированная ипотека",
      photo: "/images/clients/Nara July 2025.jpg"
    }
  ],
  ky: [
    {
      id: 1,
      name: "Гулина менен Чынгызбектин үй-бүлөсү",
      location: "Питтсбург, Пенсилвания",
      message: "Биз укмуштуу кызматка ушунчалык ыраазыбыз! Жаш үй-бүлө катары, биз эч качан кыялдагы үйбүздү сатып ала алабыз деп ойлогон эмеспиз. Команда бизди ар бир кадамдан өткөрүп, 2025-жылдын апрелинде үй ээси болуу кыялыбызды ишке ашырды!",
      loanAmount: "$350,000",
      loanType: "30 жылдык туруктуу",
      photo: "/images/clients/Gulina April 2025.jpg"
    },
    {
      id: 2,
      name: "Нара",
      location: "Спринг Брук, Пенсилвания",
      message: "Ипотека процесси жылмакай жана профессионал болду! Мен Спринг Брук шаарынан керектүү үйдү таптым жана команда каржылоону оңой кылды. 2025-жылдын августунда $515,000 үйүмдү жабуу кыялым чындыкка айланды!",
      loanAmount: "$515,000",
      loanType: "30 жылдык туруктуу ипотека",
      photo: "/images/clients/Nara July 2025.jpg"
    }
  ]
};

export const getClientTestimonials = (language = 'en') => {
  return clientTestimonials[language] || clientTestimonials.en;
};